import Sortable from "sortablejs";

if(document.querySelector('.draggable-sort')) {
    document.querySelectorAll('.draggable-sort').forEach((el) => {
        Sortable.create(el, {
            onSort: function (/**Event*/ evt) {
                [...evt.target.children].forEach((el, i) => {
                    el.querySelector('b').innerText = (i + 1) + '.';
                    el.querySelector('input[type="hidden"]').value = (i + 1) * 100;
                })
            },
        });
    })
}
